<template>
    <section class="experienceTemp">
        <div class="gallery" ref="gallery">

            <img v-for="(image, i) in experienceModel.gallery" :src="image" :key="i" :class="`slide-${i+1}`" alt="Gallery content">
            <!-- Here goes an image collection -->
            
        </div>

        <div class="info">
            <div class="logo">
                <img :src="experienceModel.placeLogo" alt="logo">
            </div>
            <div class="content">
                <h2>{{experienceModel.place}}</h2>
                <span>{{experienceModel.role}}</span>
                <span class="timespam">{{timeFormat(experienceModel.startDate, experienceModel.endDate)}}</span>
                <p>{{experienceModel.placeDesc}}</p>
            </div>

        </div>

        <div class="genContent">

            <p v-for="(content, i) in experienceModel.roleStory" :class="content.startsWith('<') && content.endsWith('>') ? 'role' : ''" :key="i">
                {{cleanContent(content)}}
            </p>

        </div>
    </section>
</template>

<script>

export default {
    name: "ExperienceFull",
    props: {
        experienceModel: Object
    },
    data() {
        return {
            slideCount: 3,
            slideTimer: undefined
        }
    },
    methods: {
        slideStep(index) {
            if(!index) index = 1;

            if(index > this.slideCount) {
                return this.slideStep(1);
            }
            this.showNext(index);
            index++;
            this.slideTimer = setTimeout(() => this.slideStep(index), 7500);
        },
        showNext(index) {
            let currentSlide = this.$refs.gallery.getElementsByClassName(`slide-${index}`);
            let previousSlide = this.$refs.gallery.getElementsByClassName(`slide-${index == 1 ? this.slideCount : index -1}`);
            
            currentSlide[0].style.width = "100%";
            currentSlide[0].style.visibility = "visible";
            currentSlide[0].style.opacity = "0.5";

            previousSlide[0].style.visibility = "hidden";
            previousSlide[0].style.opacity = "0";
            previousSlide[0].style.width = "0%";
        },
        timeFormat(initDate, endDate) {
            let dateInit = new Date(initDate);
            let dateEnd = new Date(endDate);

            if(dateEnd < dateInit) dateEnd = new Date();
            
            let initMonth = dateInit.toLocaleString('default', { month: 'long' });
            let endMonth = dateEnd.toLocaleString('default', { month: 'long' });

            let span = this.spanFormat(dateInit, dateEnd);

            return `from ${initMonth} ${dateInit.getFullYear()} until ${endMonth} ${dateEnd.getFullYear()} (${span})`;
        },
        spanFormat(dateInit, dateEnd) {
            let dateDifference = dateEnd.getTime() - dateInit.getTime();
            let longTime = Math.round((dateDifference / (1000*60*60*24*30*12)) * 10) / 10;
            
            let longComponents = `${longTime}`.split(".");

            let years = longComponents[0];
            let months = (Number(longComponents[1]) / 12) * 12;

            let yPluralize = years > 1;
            let mPluralize = months > 1;

            return `Approximately 
            ${years > 0 ? years + ' year' + (yPluralize ? 's' : '')  : ''}
            ${months > 0 && years > 0 ? ' and ' : ''}
            ${months > 0 ? months + ' month' +( mPluralize ? 's' : '') : ''}`

        },
        cleanContent(content) {
            return content.replace(">","").replace("<","");
        }
    },
    mounted() {
        this.slideStep();
    },
    destroyed() {
        clearTimeout(this.slideTimer);
    }
}

</script>

<style scoped lang="scss">
.experienceTemp {
    width: 90%;
    margin-top: 50px;
    margin-bottom: 10px;

    border-radius: 5px;
    box-shadow: 0px 0px 5px #000000ab;
    -webkit-backdrop-filter: blur(6.2px);
    backdrop-filter: blur(6.2px);

    transition: background-color .4s;
}
.gallery {
    width: 100%;
    height: 350px;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    img {
        width: 0%;
        height: 100%;
        object-fit: cover;
        opacity: 0;
        visibility: hidden;
        transition: opacity .5s;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
    }
}

.info {
    display: flex;
    padding: 0 40px 0 40px;
    .logo {
        margin-top: -100px;
        z-index: 10;
        img {
            width: 250px;
            height: 250px;
            background-color: #fff;
            border-radius: 50%;
        }
    }
    .content {
        margin: 5px 25px 0 10px;
        padding: 0 15px;
        text-align: left;
        width: 65%;
        p {
            text-align: justify;
            margin-top: 10px;
            margin-left: 25px;
            
            line-height: 20px;
            font-size: 14px;
            color: #000000d3;
        }
        h2 {
            font-size: 45px;
            font-weight: bold;
        }
        span {
            margin-left: 25px;
            font-weight: bold;
            font-size: 20px;
            display: block;
        }
        .timespam {
            font-weight: lighter;
            font-size: 14px;
            font-style: italic;
            color: #484848;
            margin-top: 5px;

        }
    }
}

.genContent {
    min-height: 5vh;
    margin: 15px;
    padding: 10px;

    p {
        text-align: justify;
        margin: 0 5.5vw 20px 5.5vw;
        line-height: 24px;
    }
    .role {
        border-left: 5px solid black;
        padding: 8px 10px 8px 20px;
        margin: 0px 10vw 30px 10vw;
        background-color: #00000035;
        box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.4);
    }
}

    @media (prefers-color-scheme: dark) {
        .experienceTemp {
            background-color: #00000044;
        }

    }

    @media (prefers-color-scheme: light) {
        .experienceTemp {
            background-color: #ffffff44;
        }
    }

    @media screen and (max-width: 950px) {
        .info {
            flex-direction: column;
            padding: 0 40px 0 40px;

            .content {
                margin: 5px auto;
                padding: 0px;
                text-align: center;
                width: auto;
                max-width: 75%;
                p {
                    margin-left: 0px;
                }
                span {
                    margin-left: 0px;
                }
            }
        }
    }

    @media screen and (max-width: 600px) {
        .info {
            padding: 0 2.5vw 0 2.5vw;
            .content {
                max-width: 85%;
            }
            .logo {
                img {
                    width: 200px;
                    height: 200px;
                }
            }
        }

        .genContent {
            margin: 10px;
            padding: 5px;

            p {
                margin: 0 1vw 20px 1vw;
            }
            .role {
                padding: 8px 10px 8px 20px;
                margin: 0px 5vw 30px 5vw;
            }
        }
    }

    @media screen and (max-width: 450px) {
        .experienceTemp {
            width: 97%;
        }
    }


</style>